_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[24],{

/***/ "+iML":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore",
      function () {
        return __webpack_require__("HtZD");
      }
    ]);
  

/***/ }),

/***/ "3bhu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HeaderUnAuthenticated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Header; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("YFqc");
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_header_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ffJT");
/* harmony import */ var _styles_header_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_header_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_UseLoggedIn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("qdsK");
/* harmony import */ var _lib_api_useHost__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("i082");
/* harmony import */ var _contexts_domain_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("Pmb8");
/* harmony import */ var _lib_domainUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("b3kR");
var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;







function HeaderUnAuthenticated(props) {
  var signup = props.signup,
      login = props.login,
      about = props.about,
      explore = props.explore;

  var _useHost = Object(_lib_api_useHost__WEBPACK_IMPORTED_MODULE_4__[/* useHost */ "c"])(),
      onCustomDomain = _useHost.onCustomDomain;

  return __jsx("div", {
    className: _styles_header_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a["header"]
  }, __jsx("div", {
    className: _styles_header_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a["navbar"]
  }, __jsx(Logo, {
    goTo: _lib_UseLoggedIn__WEBPACK_IMPORTED_MODULE_3__[/* goToIndex */ "a"]
  }), __jsx("div", {
    className: _styles_header_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a["menu-items"]
  }, signup ? __jsx(next_link__WEBPACK_IMPORTED_MODULE_1___default.a, {
    href: "".concat(Object(_lib_domainUtils__WEBPACK_IMPORTED_MODULE_6__[/* getHomeDomain */ "a"])(), "/signup")
  }, __jsx("a", null, "Signup")) : __jsx("div", null), login ? __jsx(next_link__WEBPACK_IMPORTED_MODULE_1___default.a, {
    href: "/login"
  }, __jsx("a", null, "Login")) : __jsx("div", null), about ? __jsx(next_link__WEBPACK_IMPORTED_MODULE_1___default.a, {
    href: "".concat(Object(_lib_domainUtils__WEBPACK_IMPORTED_MODULE_6__[/* getHomeDomain */ "a"])(), "/about")
  }, __jsx("a", null, "About")) : __jsx("div", null), explore ? __jsx(next_link__WEBPACK_IMPORTED_MODULE_1___default.a, {
    href: "".concat(Object(_lib_domainUtils__WEBPACK_IMPORTED_MODULE_6__[/* getHomeDomain */ "a"])(), "/explore")
  }, __jsx("a", null, "Explore")) : __jsx("div", null))));
}
function Header(props) {
  var _useContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(_contexts_domain_context__WEBPACK_IMPORTED_MODULE_5__[/* DomainContext */ "a"]),
      username = _useContext.username,
      onCustomDomain = _useContext.onCustomDomain,
      userHost = _useContext.userHost;

  var profile = props.profile,
      settings = props.settings,
      explore = props.explore,
      logout = props.logout;
  return __jsx("div", {
    className: _styles_header_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a["header"]
  }, __jsx("div", {
    className: _styles_header_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a["navbar"]
  }, __jsx(Logo, {
    goTo: _lib_UseLoggedIn__WEBPACK_IMPORTED_MODULE_3__[/* goToLanding */ "b"]
  }), __jsx("div", {
    className: _styles_header_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a["menu-items"]
  }, profile ? __jsx("a", {
    href: Object(_lib_api_useHost__WEBPACK_IMPORTED_MODULE_4__[/* goToProfileFromLanding */ "a"])(onCustomDomain, userHost, username)
  }, "Profile") : __jsx("div", null), settings ? __jsx(next_link__WEBPACK_IMPORTED_MODULE_1___default.a, {
    href: "/settings"
  }, __jsx("a", null, "Settings")) : __jsx("div", null), explore ? __jsx(next_link__WEBPACK_IMPORTED_MODULE_1___default.a, {
    href: "/explore"
  }, __jsx("a", null, "Explore")) : __jsx("div", null), logout ? __jsx(Logout, null) : __jsx("div", null))));
}

function Logo(props) {
  return __jsx("div", {
    className: _styles_header_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a["logo"],
    onClick: props.goTo
  }, __jsx("img", {
    src: "/images/LeafLogo.svg"
  }));
}

function Logout() {
  return __jsx("div", {
    className: _styles_header_module_scss__WEBPACK_IMPORTED_MODULE_2___default.a["menu-item"],
    onClick: _lib_UseLoggedIn__WEBPACK_IMPORTED_MODULE_3__[/* logOut */ "c"]
  }, "Logout");
}

/***/ }),

/***/ "BdxU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ErroredPage; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g4pe");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;

function ErroredPage() {
  return __jsx("div", {
    className: "container"
  }, __jsx(next_head__WEBPACK_IMPORTED_MODULE_1___default.a, null, __jsx("title", null, "Leaf"), __jsx("link", {
    rel: "icon",
    href: "/favicon.ico"
  })), __jsx("main", null, __jsx("div", null, "404. Page not Found.")));
}

/***/ }),

/***/ "HtZD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__N_SSG", function() { return __N_SSG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Pages; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("g4pe");
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_UseLoggedIn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("qdsK");
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("3bhu");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("20a2");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("pKNN");
/* harmony import */ var _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ZMKu");
/* harmony import */ var _lib_useUserInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("A926");
/* harmony import */ var _lib_usePosts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("yfm8");
/* harmony import */ var _lib_api_useHost__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("i082");
/* harmony import */ var _404__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("BdxU");
/* harmony import */ var _contexts_domain_context__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("Pmb8");

var __jsx = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement;














var dayjs = __webpack_require__("Wgwc");

var __N_SSG = true;
function Pages(props) {
  var postsData = props.posts; // let { data: postsData, mutate } = useSWR("getAllPostsData", fetcher, {
  //   initialData,
  //   revalidateOnMount: true,
  // });

  var _useState = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(postsData),
      filteredPosts = _useState[0],
      filterPosts = _useState[1];

  var _useState2 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(""),
      searchFilter = _useState2[0],
      updateSearchFilter = _useState2[1];

  var _useState3 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])("All"),
      tagFilter = _useState3[0],
      updateTagFilter = _useState3[1];

  var _useState4 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])("Recent"),
      sortFilter = _useState4[0],
      updateSortFilter = _useState4[1];

  var _useState5 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      tagSelectOpened = _useState5[0],
      toggleTagSelectOpened = _useState5[1];

  var _useState6 = Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false),
      sortSelectOpened = _useState6[0],
      toggleSortSelectOpened = _useState6[1];

  var _useLoggedIn = Object(_lib_UseLoggedIn__WEBPACK_IMPORTED_MODULE_2__[/* useLoggedIn */ "d"])(),
      authenticated = _useLoggedIn.authenticated,
      error = _useLoggedIn.error,
      loading = _useLoggedIn.loading;

  var _useUserInfo = Object(_lib_useUserInfo__WEBPACK_IMPORTED_MODULE_7__[/* useUserInfo */ "a"])(authenticated),
      username = _useUserInfo.username,
      userHost = _useUserInfo.userHost;

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    searchAndFilterPosts(filterPosts, postsData, searchFilter, tagFilter, sortFilter);
  }, [searchFilter, tagFilter, sortFilter]); // TODO this needs to be fixed (re-loads anytime new post)

  Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
    filterPosts(postsData);
  }, [postsData]);

  var _useHost = Object(_lib_api_useHost__WEBPACK_IMPORTED_MODULE_9__[/* useHost */ "c"])(),
      onCustomDomain = _useHost.onCustomDomain;

  if (onCustomDomain) {
    return __jsx(_404__WEBPACK_IMPORTED_MODULE_10__["default"], null);
  }

  return __jsx("div", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["container"]
  }, __jsx(next_head__WEBPACK_IMPORTED_MODULE_1___default.a, null, __jsx("title", null, "Explore"), __jsx("link", {
    rel: "icon",
    href: "/favicon.ico"
  })), __jsx("main", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["explore-main-wrapper"]
  }, authenticated ? __jsx(_contexts_domain_context__WEBPACK_IMPORTED_MODULE_11__[/* DomainContext */ "a"].Provider, {
    value: {
      onCustomDomain: onCustomDomain,
      userHost: userHost,
      username: username
    }
  }, __jsx(_components_Header__WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"], {
    username: username,
    profile: true,
    settings: true,
    logout: true
  })) : __jsx(_components_Header__WEBPACK_IMPORTED_MODULE_3__[/* HeaderUnAuthenticated */ "a"], {
    login: true,
    signup: true,
    about: true
  }), __jsx(TitleText, null), __jsx("div", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["search-and-filter"]
  }, __jsx(framer_motion__WEBPACK_IMPORTED_MODULE_6__[/* AnimatePresence */ "a"], null, __jsx(framer_motion__WEBPACK_IMPORTED_MODULE_6__[/* motion */ "b"].div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.4
    }
  }, __jsx(SearchBar, {
    updateSearchFilter: updateSearchFilter
  }))), __jsx("div", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["selections"]
  }, __jsx(framer_motion__WEBPACK_IMPORTED_MODULE_6__[/* AnimatePresence */ "a"], null, __jsx(framer_motion__WEBPACK_IMPORTED_MODULE_6__[/* motion */ "b"].div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.4
    }
  }, __jsx(TagSelect, {
    updateTagFilter: updateTagFilter,
    tagFilter: tagFilter,
    tagSelectOpened: tagSelectOpened,
    toggleTagSelectOpen: toggleTagSelectOpened,
    toggleSortSelectOpen: toggleSortSelectOpened
  }))), __jsx(framer_motion__WEBPACK_IMPORTED_MODULE_6__[/* AnimatePresence */ "a"], null, __jsx(framer_motion__WEBPACK_IMPORTED_MODULE_6__[/* motion */ "b"].div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.4
    }
  }, __jsx(SortSelect, {
    updateSortFilter: updateSortFilter,
    sortFilter: sortFilter,
    sortSelectOpened: sortSelectOpened,
    toggleTagSelectOpen: toggleTagSelectOpened,
    toggleSortSelectOpen: toggleSortSelectOpened
  }))))), __jsx(DisplayPosts, {
    posts: filteredPosts,
    updateTagFilter: updateTagFilter
  })));
}

function TitleText() {
  return __jsx("div", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["explore-title"]
  }, __jsx("div", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["explore-title-text"]
  }, "Discover Library"));
} // this will combine searchFilter, tagFilter, and sortFilter to give filtered results


function searchAndFilterPosts(filterPosts, allPosts, searchFilter, tagFilter, sortFilter) {
  var newPosts = Array.from(allPosts).filter(function (post) {
    return post["title"].toLowerCase().includes(searchFilter.toLowerCase());
  });

  if (tagFilter !== "All") {
    newPosts = Array.from(newPosts).filter(function (post) {
      return typeof post["tags"] !== "undefined";
    });
    newPosts = newPosts.filter(function (post) {
      return post["tags"].includes(tagFilter);
    });
  }

  switch (sortFilter) {
    case "Date":
      {
        newPosts.sort(function (a, b) {
          var keyA = a.publishedAt._seconds,
              keyB = b.publishedAt._seconds;
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });
        break;
      }

    case "Recent":
      {
        newPosts.sort(function (a, b) {
          var keyA = a.publishedAt._seconds,
              keyB = b.publishedAt._seconds;
          if (keyA > keyB) return -1;
          if (keyA < keyB) return 1;
          return 0;
        });
        break;
      }

    case "Title":
      {
        newPosts.sort(function (a, b) {
          var keyA = a.title.toLowerCase(),
              keyB = b.title.toLowerCase();
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });
        break;
      }

    case "Author":
      {
        newPosts.sort(function (a, b) {
          var keyA = a.username.toLowerCase(),
              keyB = b.username.toLowerCase();
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });
        break;
      }
  }

  filterPosts(newPosts);
} // TODO want to implement google-search like suggestions for tags


function SearchBar(props) {
  return __jsx("div", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["search"]
  }, __jsx("input", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["search-bar"],
    placeholder: "Search for a title",
    onChange: function onChange(e) {
      return props.updateSearchFilter(e.target.value);
    }
  }), __jsx("img", {
    src: "images/search.svg"
  }));
}

function TagSelect(props) {
  var webdev = ["Angular", "Front End", "HTML", "Javascript", "PHP", "React", "Web Dev"];
  var lang = ["Go", "Java", "Python", "Ruby"];
  var backend = ["APIs", "AWS", "Back End", "Django", "Google Cloud", "NextJS"];
  var mobile = ["Android", "iOS"];
  var data = ["Algorithms", "Data Science", "Machine Learning"];
  var other = ["All", "Design", "Documentation", "Other"];
  var allTags = [backend, data, lang, mobile, webdev, other];
  var order = ["Backend", "Data", "Languages", "Mobile", "Web", "Other"];
  return __jsx("div", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["filter"]
  }, __jsx("div", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["filter-dropdown"]
  }, __jsx("button", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["filter-dropbtn"],
    onClick: function onClick() {
      props.toggleTagSelectOpen(!props.tagSelectOpened);
      props.toggleSortSelectOpen(false);
    }
  }, __jsx("img", {
    src: "images/filter.svg"
  })), __jsx(framer_motion__WEBPACK_IMPORTED_MODULE_6__[/* AnimatePresence */ "a"], null, props.tagSelectOpened && __jsx(framer_motion__WEBPACK_IMPORTED_MODULE_6__[/* motion */ "b"].div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.4
    }
  }, props.tagSelectOpened ? __jsx(TagSelectDropDown, {
    allTags: allTags,
    order: order,
    tagFilter: props.tagFilter,
    updateTagFilter: props.updateTagFilter
  }) : __jsx("div", null)))));
}

function TagSelectDropDown(props) {
  return __jsx("div", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["filter-dropdown-content"]
  }, __jsx("div", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["filter-row"]
  }, props.allTags.map(function (tagsArr, index) {
    return __jsx("div", {
      className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["filter-column"]
    }, __jsx("h3", null, props.order[index]), tagsArr.map(function (tag) {
      return tag === props.tagFilter ? __jsx("a", {
        className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["filter-selected-option"],
        onClick: function onClick(e) {
          return props.updateTagFilter(tag);
        }
      }, tag) : __jsx("a", {
        onClick: function onClick(e) {
          return props.updateTagFilter(tag);
        }
      }, tag);
    }));
  })));
}

function SortSelect(props) {
  var sortOptions = ["Recent", "Date", "Title", "Author"];
  return __jsx("div", null, __jsx("div", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["sort-dropdown"]
  }, __jsx("button", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["sort-dropbtn"],
    onClick: function onClick() {
      props.toggleSortSelectOpen(!props.sortSelectOpened);
      props.toggleTagSelectOpen(false);
    }
  }, __jsx("img", {
    src: "images/sort.svg"
  })), __jsx(framer_motion__WEBPACK_IMPORTED_MODULE_6__[/* AnimatePresence */ "a"], null, props.sortSelectOpened && __jsx(framer_motion__WEBPACK_IMPORTED_MODULE_6__[/* motion */ "b"].div, {
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.4
    }
  }, props.sortSelectOpened ? __jsx(SortSelectDropDown, {
    sortOptions: sortOptions,
    sortFilter: props.sortFilter,
    updateSortFilter: props.updateSortFilter
  }) : __jsx("div", null)))));
}

function SortSelectDropDown(props) {
  return __jsx("div", {
    className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["sort-dropdown-content"]
  }, __jsx("div", null, props.sortOptions.map(function (option) {
    return option === props.sortFilter ? __jsx("a", {
      className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["sort-selected-option"],
      onClick: function onClick(e) {
        return props.updateSortFilter(option);
      }
    }, option) : __jsx("a", {
      onClick: function onClick(e) {
        return props.updateSortFilter(option);
      }
    }, option);
  })));
}

function DisplayPosts(props) {
  try {
    var router = Object(next_router__WEBPACK_IMPORTED_MODULE_4__["useRouter"])();
    return __jsx("div", null, props.posts.length === 0 || props.posts.length === undefined ? props.posts.length === 0 ? __jsx("h3", null, "No posts found") : __jsx("div", {
      className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["post-loading"]
    }) : __jsx("div", null, Array.from(props.posts).map(function (post) {
      return __jsx("div", {
        className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["post-explore"],
        onClick: function onClick() {
          return Object(_lib_usePosts__WEBPACK_IMPORTED_MODULE_8__[/* goToPostFromExplore */ "b"])(post);
        }
      }, __jsx("div", {
        className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["post-title-explore"]
      }, post["title"]), __jsx("div", {
        className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["post-date"]
      }, dayjs(post["publishedAt"]._seconds * 1000).format("MMMM D YYYY")), __jsx("div", {
        className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["post-tags-author"]
      }, post["tags"] !== undefined ? post["tags"].map(function (tag) {
        return __jsx("div", {
          className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["post-tag"],
          onClick: function onClick(e) {
            props.updateTagFilter(tag);
            e.stopPropagation();
          }
        }, __jsx("div", {
          className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["post-tag-text"]
        }, tag));
      }) : __jsx("div", null), __jsx("div", {
        className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["post-author-name-and-img"],
        onClick: function onClick(e) {
          router.push(post["username"]);
          e.stopPropagation();
        }
      }, post["profileImage"] !== undefined && __jsx("div", {
        className: _styles_explore_module_scss__WEBPACK_IMPORTED_MODULE_5___default.a["published-post-author-img"]
      }, post["profileImage"] !== "" && __jsx("img", {
        src: post["profileImage"]
      })), __jsx("div", null, post["username"]))));
    })));
  } catch (_unused) {
    console.log("error fetching posts");
    return __jsx("div", null, __jsx("h3", null, "Error Fetching Posts"));
  }
}

/***/ }),

/***/ "ffJT":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"logo":"header_logo__ZHkcG","header":"header_header__2q1wF","navbar":"header_navbar__3Tbm7","menu-items":"header_menu-items__nAog9","menu-item":"header_menu-item__1uEaH","Login":"header_Login__HcYa0"};

/***/ }),

/***/ "pKNN":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"explore_container__3cY2k","explore-main-wrapper":"explore_explore-main-wrapper__aNAGG","Header":"explore_Header__TgaZe","explore-title":"explore_explore-title__2M36_","explore-title-text":"explore_explore-title-text__32uYb","search-and-filter":"explore_search-and-filter__1-FaV","search":"explore_search__29hmh","search-bar":"explore_search-bar__285db","selections":"explore_selections__1r1zE","filter":"explore_filter__3hvVP","filter-dropdown":"explore_filter-dropdown__1AygM","filter-dropbtn":"explore_filter-dropbtn__g6DeV","filter-dropdown-content":"explore_filter-dropdown-content__1kTFH","filter-column":"explore_filter-column__2MDF0","filter-selected-option":"explore_filter-selected-option__amdhy","filter-row":"explore_filter-row__34KRj","sort-dropdown":"explore_sort-dropdown__2U5gl","sort-dropbtn":"explore_sort-dropbtn__3Y_ae","sort-dropdown-content":"explore_sort-dropdown-content__2jZ7x","sort-selected-option":"explore_sort-selected-option__214DK","post-explore":"explore_post-explore__2jJQd","post-title-explore":"explore_post-title-explore__180Co","post-date":"explore_post-date__3ezJE","post-tags-author":"explore_post-tags-author__1sHmP","post-tag":"explore_post-tag__2DDJ5","post-tag-text":"explore_post-tag-text__vzShq","post-author-name-and-img":"explore_post-author-name-and-img__36wRo","published-post-author-img":"explore_published-post-author-img__3EuHi","post-loading":"explore_post-loading__3ejmx","spin":"explore_spin__3yjqb"};

/***/ })

},[["+iML",0,2,5,1,3,4,6,8]]]);